import * as React from 'react';
import classNames from 'classnames';
import { ConfigConsumer } from '../config-provider';
import AnchorContext from './context';
class AnchorLink extends React.Component {
    constructor() {
        super(...arguments);
        this.handleClick = (e) => {
            const { href, title, disabled } = this.props;
            if (disabled) {
                e.preventDefault();
                return;
            }
            const { scrollTo, onClick } = this.context;
            if (onClick) {
                onClick(e, { title, href });
            }
            scrollTo(href);
        };
        this.handleMousehover = (active, isEnter) => {
            if (active) {
                const { inkRef } = this.context;
                const cla = inkRef.current.getAttribute('class');
                inkRef.current.setAttribute('class', isEnter ? `${cla} hover` : cla.replace('hover', '').trim());
            }
        };
        this.handleMouseClick = (active, isDown) => {
            if (active) {
                const { inkRef } = this.context;
                const cla = inkRef.current.getAttribute('class');
                inkRef.current.setAttribute('class', isDown ? `${cla} click` : cla.replace('click', '').trim());
            }
        };
        this.renderAnchorLink = ({ getPrefixCls }) => {
            const { prefixCls: customizePrefixCls, href, title, className, style, target, disabled, children, } = this.props;
            const prefixCls = getPrefixCls('anchor', customizePrefixCls);
            const active = this.context.activeLink === href;
            const wrapperClassName = classNames(`${prefixCls}-link`, {
                [`${prefixCls}-link-active`]: active
            }, className);
            const titleClassName = classNames(`${prefixCls}-link-title`, {
                [`${prefixCls}-link-title-active`]: active,
                [`${prefixCls}-link-title-disabled`]: disabled
            });
            return (<div className={wrapperClassName} style={style}>
                <a className={titleClassName} href={href} title={typeof title === 'string' ? title : ''} target={target} onMouseEnter={() => this.handleMousehover(active, true)} onMouseLeave={() => this.handleMousehover(active, false)} onMouseDown={() => this.handleMouseClick(active, true)} onMouseUp={() => this.handleMouseClick(active, false)} onClick={this.handleClick}>
                    {title}
                </a>
                {children}
            </div>);
        };
    }
    componentDidMount() {
        this.context.registerLink(this.props.href);
    }
    componentDidUpdate({ href: prevHref }) {
        const { href } = this.props;
        if (prevHref !== href) {
            this.context.unregisterLink(prevHref);
            this.context.registerLink(href);
        }
    }
    componentWillUnmount() {
        this.context.unregisterLink(this.props.href);
    }
    render() {
        return <ConfigConsumer>{this.renderAnchorLink}</ConfigConsumer>;
    }
}
AnchorLink.defaultProps = {
    href: '#'
};
AnchorLink.contextType = AnchorContext;
export default AnchorLink;
